import { jsx as _jsx } from "react/jsx-runtime";
import fitty from 'fitty';
import { useEffect, useRef } from 'react';
import { styled } from 'styled-components';
export const Fitty = ({ children, minSize, maxSize, multiLine, observeMutations, className, }) => {
    const ref = useRef(null);
    const fittyRef = useRef(undefined);
    useEffect(() => {
        const el = ref.current;
        if (!el) {
            return;
        }
        const options = {
            minSize,
            maxSize,
            multiLine,
            observeMutations,
        };
        fittyRef.current = fitty(el, options);
    }, [maxSize, minSize, observeMutations, multiLine]);
    return (_jsx(Root, { ref: ref, className: className, children: children }));
};
const Root = styled.div `
  display: inline-block;
`;
//# sourceMappingURL=fitty.js.map